import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AbstractActionService} from "../../../../core/service/v2/service/action/abstractAction.service";
import {CustomizeHttpUrlGenerator} from "../../../../../store/core/url/customizeHttpUrlGenerator";
import {TagSummaryModel} from "../model/tagSummary.model";
import {TagRepository} from "../../impl/service/ngrx/tag.repository";
import {TagSummaryConverter} from "../model/tagSummary.converter";

@Injectable()
export class TagGetAllByEntityTypeAndEntityIdActionService
    extends AbstractActionService<TagGetAllByEntityTypeAndEntityIdActionPayload, TagSummaryModel[]> {

    public constructor(customizeHttpUrlGenerator: CustomizeHttpUrlGenerator,
                       httpClient: HttpClient,
                       private converter: TagSummaryConverter,
                       private repository: TagRepository) {
        super('Tag', 'get-by-entityTypeValue-and-entityId', customizeHttpUrlGenerator, httpClient);
    }

    protected buildResponse(response: any): TagSummaryModel[] {
        return this.converter.convertFromArray(response);
    }
}

export class TagGetAllByEntityTypeAndEntityIdActionPayload {
    entityTypeValue: string;
    entityId: number;
}
